import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_MES_67 } from "@/lib/programData";

export default function MarrakechEssaouira67Page() {
  return <ProgramTemplate program={PROGRAM_MES_67} variant="mes" showJourneyChronology />;
}
